import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  @Input() variant: 'success' | 'danger' | 'warning' | 'info' = 'info';
  @Input() dismissible = false;
  @Input() icon = true;

  @Output() dismissed = new EventEmitter<void>();

  isVisible = true;

  onDismiss(): void {
    this.isVisible = false;
    this.dismissed.emit();
  }
}

